import { Container, Row, Col, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
// Component
// import Button1 from "../../pages/home/components/orderbtn/button";
// img
import FMBImg from "./assets/img/fklogo.png";
import Table from "react-bootstrap/Table";
// Icon
import {
  FaMapMarkedAlt,
  FaPhoneSquareAlt,
  FaEnvelope,
  FaInstagramSquare,
  FaFacebookSquare,
  FaTwitterSquare,
  FaTripadvisor,
  FaYoutubeSquare,
  FaCcMastercard,
  FaCcVisa,
  FaCcAmex,
  FaCcDiscover,
  FaCcPaypal,
  FaTiktok
} from "react-icons/fa";
// Scss
import "./assets/scss/footer.scss";
import { getFooter } from "../../../actions/home/footerAction";
import { getSocial } from "../../../actions/home/socialAction";
import { connect } from "react-redux";
import React, { useEffect, useState } from "react";
import { OrderFlow } from "../../../../src/App";
import AppLinker from "../appLinks/appLinks"

function Footer({ response, social }) {
  const { setBusinessTitle, setClientCheck } = OrderFlow();
  const [getFooterData, setFooterData] = useState();
  const [footerbg,setFooterbg]=useState(null);
  const[footercolor,setFooterColor]=useState(null);
  const [getBusinessname, setBusinessname] = useState();
  const [emailClicked, setEmailClicked] = useState(false);

  useEffect(() => {
    // Add the preload link to the document head
    const link = document.createElement("link");
    link.rel = "preload";
    link.href =
      "https://maps.gstatic.com/maps-api-v3/embed/js/57/3a/init_embed.js";
    link.as = "script";
    document.head.appendChild(link);

    // Clean up the link element when the component unmounts
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  const domain = window.location.hostname;
  console.log(domain);
  const expectedDomain = 'dosanchutney.uk';
  useEffect(() => {
    if (response) {
      console.log(response);
      setFooterData(response?.data?.footer);
      setBusinessname(response?.data?.header?.businessName)
      // alert(JSON.stringify(response?.data?.header?.businessName));

      setClientCheck(response?.data?.footer?.contactus?.path);
      localStorage.setItem("path", response?.data?.footer?.contactus?.path);
      localStorage.setItem("name", response?.data?.footer?.contactus?.name);
      localStorage.setItem("footerEmail",response?.data?.footer?.contactus?.email);
      localStorage.setItem(
        "address1",
        response?.data?.footer?.contactus?.address1
      );
      localStorage.setItem(
        "address2",
        response?.data?.footer?.contactus?.address2
      );
      localStorage.setItem("city", response?.data?.footer?.contactus?.city);
      localStorage.setItem(
        "pincode",
        response?.data?.footer?.contactus?.pincode
      );

      if (
        response?.data?.header?.businessName &&
        response?.data?.footer?.contactus?.city
      ) {
        setBusinessTitle(
          response.data.header.businessName +
          " in " +
          response.data.footer.contactus.city
        );
      } else {
        setBusinessTitle("");
      }

      if (response?.data?.theme) {
        const { background, color } = response.data.theme;
        const root = document.documentElement;
        root.style.setProperty("--theme-background", background);
        root.style.setProperty("--theme-color", color);
        if (color == "#ffffff") {
          root.style.setProperty("--theme-color-only", background);
        } else {
          root.style.setProperty("--theme-color-only", color);
        }
      }
      if( response?.data?.footer?.footerCss){
       const {backgroundColor,foregroundColor}=response?.data?.footer?.footerCss;
       const footerBackground=backgroundColor?backgroundColor:'#010f1c';
       const footerColor=foregroundColor?foregroundColor:'#fff';
       setFooterbg(footerBackground);
       setFooterColor(footerColor);
      }
    }
  }, [response]);

  const FooterLinks = [
    {
      name: "Privacy Policy",
      url: "/privacy",
    },
    {
      name: "Terms & Condition",
      url: "/terms",
    },
    {
      name: "Allergy Information",
      url: "/allergy",
    },
  ];
  // Encode URL parameters
  const address1 = encodeURIComponent(getFooterData?.contactus?.address1 || "");
  const address2 = encodeURIComponent(getFooterData?.contactus?.address2 || "");
  const city = encodeURIComponent(getFooterData?.contactus?.city || "");
  const state = encodeURIComponent(getFooterData?.contactus?.state || "");
  const pincode = encodeURIComponent(getFooterData?.contactus?.pincode || "");

  // Construct the URL
  const mapSrc = `https://www.google.com/maps/embed/v1/place?key=AIzaSyCgf7rRcA3ri_3U-VQ9lFs7N0tNFItm3lI&q=${address1},${address2},${city},${state},${pincode}`;

  return (
    <>
      <span id="contact-nav"></span>
      {getFooterData ? (
        <footer
          style={{
            backgroundColor:footerbg,
            color: footercolor,
          }}
          height="700"
          width="100%"
        >
          <Container>
            <Row>
              <Col xxl={3} xl={3} lg={3} md={6} sm={6}>
                <div className="contact-box address">
                  <ContactTitle title="Contact Us" />
                  <ul>
                    <li>
                      <FaMapMarkedAlt />
                      {getFooterData.contactus?.address1},<br />
                      {getFooterData.contactus?.address2 && (
                        <>
                          {getFooterData.contactus?.address2},<br />
                        </>
                      )}{" "}
                      {getFooterData.contactus?.city},{" "}
                      {getFooterData.contactus?.pincode}.
                    </li>
                    <li>
                      <FaPhoneSquareAlt />
                      <a href={`tel:${getFooterData.contactus?.mobile}`}>
                        {getFooterData.contactus?.mobile}
                      </a>
                    </li>
                    <li>
                      <FaEnvelope />
                      <a
                        href={`mailto:${getFooterData.contactus?.email}`}
                        style={{ color: emailClicked ? "red" : "blue" }}
                        onClick={() => setEmailClicked(true)}
                      >
                        {getFooterData.contactus?.email}
                      </a>
                    </li>
                  </ul>
                  <br />
                  {social?.message?.social && (
                    <>
                      <ContactTitle title="Get Social" />
                      <ul>
                        {social.message.social.google && (
                          <li>
                            <FaTripadvisor />
                            <a
                              target="__blank"
                              href={`${social.message.social.google}`}
                            >
                              Trip Advisor
                            </a>
                          </li>
                        )}
                        {social.message.social.instagram && (
                          <li>
                            <FaInstagramSquare />
                            <a
                              target="__blank"
                              href={`${social.message.social.instagram}`}
                            >
                              Instagram
                            </a>
                          </li>
                        )}
                        {social.message.social.facebook && (
                          <li>
                            <FaFacebookSquare />
                            <a
                              target="__blank"
                              href={`${social.message.social.facebook}`}
                            >
                              Facebook
                            </a>
                          </li>
                        )}
                        {social.message.social.twitter && (
                          <li>
                            <FaTwitterSquare />
                            <a
                              target="__blank"
                              href={`${social.message.social.twitter}`}
                            >
                              Twitter
                            </a>
                          </li>
                        )}
                        {social.message.social.youtube && (
                          <li>
                            <FaYoutubeSquare />
                            <a
                              target="__blank"
                              href={`${social.message.social.youtube}`}
                            >
                              Youtube
                            </a>
                          </li>
                        )}
                        {domain == expectedDomain && (
                          <li>
                            <FaTiktok />
                            <a
                              target="__blank"
                              href="https://www.tiktok.com/@dosa.n.chutney.tooting"
                            >
                              TikTok
                            </a>
                          </li>)}
                      </ul>
                    </>
                  )}
                </div>
              </Col>
              <Col xxl={3} xl={3} lg={2} md={6} sm={6}>
                <div className="contact-box map">
                  <ContactTitle title="Location" />
                  <iframe
                    src={mapSrc}
                    width="100%"
                    height="150px"
                    style={{ border: "4px solid #fff", borderRadius: "5px" }}
                    allowFullScreen=""
                    loading="lazy"
                    title="myFrame"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </Col>
              <Col xxl={3} xl={3} lg={4} md={7} sm={7}>
                {/* <div className="contact-box timing">
                  <ContactTitle title="Opening Hours" />
                  <ul>
                    {getFooterData.opening_hours.map((day, index) => (
                      <li key={index}>
                        <FaClock />
                        {Object.keys(day).map((key) => (
                          <div key={key}>
                            {key}:{' '}
                            <span>
                              Collection: {day[key].collection.join(', ')} <br />
                              Delivery: {day[key].delivery.join(', ')}
                            </span>
                          </div>
                        ))}
                        <hr />
                      </li>
                    ))}
                  </ul>
                </div> */}

                <div className="contact-box timing">
                  <ContactTitle title="Opening Hours" />
                  <Table className="opening-time-head">
                    <thead style={{ color: "white" }}>
                      <tr>
                        <th>Day</th>
                        <th>Timing</th>
                      </tr>
                    </thead>
                  </Table>
                  <Table className="opening-time-data">
                    <tbody style={{ color: "white" }}>
                      {getFooterData?.getDays?.map((dayGroup, index) => (
                        <React.Fragment key={index}>
                          {dayGroup.map((day, innerIndex) => (
                            <tr key={innerIndex} className="">
                              <td> {day.days.substring(0, 3)}:</td>
                              <td>{day.contact_us}</td>
                            </tr>
                          ))}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Col>
              <Col xxl={3} xl={3} lg={3} md={5} sm={5}>
                <div className="contact-box food-hygiene">
                  <ContactTitle title="Food Hygiene" />
                  <Image src={getFooterData.food_hygiene} fluid alt={getBusinessname} width={250}
                    height={150} />
                </div>
                <AppLinker/>
              </Col>
              
              <hr className="copy-top" />
            </Row>
          </Container>
          <section className="footer-bottom">
            <Container>
              <Row className="align-items-center">
                <Col xxl={12} xl={12}>
                  <div className="copy-right-content">
                    <a
                      href="https://fusionmybusiness.com/"
                      target="_blank"
                      rel="noreferrer"
                      className="fmblogo-mob"
                    >
                      <Image src={FMBImg} fluid alt={getBusinessname} />
                    </a>
                    <p>
                      Copyright © {new Date().getFullYear()} | All Rights
                      Reserved.
                    </p>
                    <a
                      href="https://fusionkitchen.co.uk/partner"
                      target="_blank"
                      rel="noreferrer"
                      className="fmblogo-desk"
                    >
                      <Image src={FMBImg} fluid alt={getBusinessname} width="80" height="50" />
                    </a>
                    <div className="footer-link">
                      <ul>
                        {FooterLinks.map((FooterLink, index) => (
                          <li key={index}>
                            <Link to={FooterLink.url}>{FooterLink.name}</Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="payment-icon">
                      <FaCcMastercard />
                      <FaCcVisa />
                      <FaCcAmex />
                      <FaCcDiscover />
                      <FaCcPaypal />
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        </footer>
      ) : null}
    </>
  );
}

const ContactTitle = (props) => {
  return (
    <>
      <h3>{props.title}</h3>
      <div className="bottom-hr"></div>
    </>
  );
};

const mapStateToProps = (state) => ({
  response: state.footer.response,
  social: state.social.response,
});

const mapDispatchToProps = {
  getFooter,
  getSocial,
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
